export default "__VITE_ASSET__Dnh7JJVt__"